<div class="translations-status">
  <div class="translations-status__counts fs__sm">
    <div>
      <span class="fw__700 translated"> {{ translatedCount$() }}</span>
      <span> Translated</span>
    </div>

    <div>
      <span class="fw__700 missing"> {{ missingCount$() }}</span>
      <span> Missing</span>
    </div>

    <div>
      <span class="fw__700 outdated"> {{ outdatedCount$() }} </span>
      <span> Outdated</span>
    </div>

    <div>
      <span class="fw__700 ignored"> {{ ignoredCount$() }} </span>
      <span> Ignored</span>
    </div>
  </div>

  <div class="translations-status__progress">
    <eiq-progress-bar [segments]="segments$()" [max]="total$()"></eiq-progress-bar>
  </div>
</div>
